import { Inject, Injectable } from '@angular/core'
import { AuthContextStorageService } from '../../../core/auth/auth-context-storage.service'
import { UserContextStorageService } from '../../../core/auth/user-context/user-context-storage.service'
import { firstValueFrom } from 'rxjs'
import {
    ContractParamTemplate, DocumentTemplate,
    DocumentTemplateControllerService,
    ListResponseContractParamTemplate, ListResponseDocumentTemplate,
    ParamTemplateControllerService,
} from '../../../api/backend'

@Injectable({
    providedIn: 'root'
})
export class ContractTemplateDatastore {

    private subcontractParamTemplates: Array<ContractParamTemplate> = []
    private contractDocumentTemplates: Array<DocumentTemplate> = []
    private subcontractDocumentTemplates: Array<DocumentTemplate> = []
    private purchaseDocumentTemplates: Array<DocumentTemplate> = []

    constructor(@Inject(DocumentTemplateControllerService) private documentTemplateControllerService: DocumentTemplateControllerService,
                @Inject(ParamTemplateControllerService) private paramTemplateControllerService: ParamTemplateControllerService,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
                @Inject(UserContextStorageService) protected userContextStorageService: UserContextStorageService,) {
    }

    /**
     * Returns promise with loaded contract templates. Templates are loaded only once
     * @returns {Promise}
     */
    getContractParamTemplates(): Promise<Array<ContractParamTemplate>> {
        //CA-10563 - removed loading from datastore to allow application of changes from another browser tab without reload of app
        return firstValueFrom(this.paramTemplateControllerService.getAllParamTemplates(
            this.authContextStorageService.getProjectKey(),
            true,
            false
        )).then((data: ListResponseContractParamTemplate) => data.items)
    }

    getContractDocumentTemplates(combined): Promise<Array<DocumentTemplate>> {
        return new Promise(resolve => {
            if (this.contractDocumentTemplates?.length) {
                resolve(this.contractDocumentTemplates)
            } else {
                this.documentTemplateControllerService.getAllDocumentTemplates(
                    this.authContextStorageService.getProjectKey(),
                    true,
                    ['CONTRACT'],
                    combined
                ).subscribe((data: ListResponseDocumentTemplate) => {
                    this.contractDocumentTemplates = data.items

                    resolve(data.items)
                })
            }
        })
    }

    getPurchaseDocumentTemplates(): Promise<Array<DocumentTemplate>> {
        return new Promise(resolve => {
            if (this.purchaseDocumentTemplates?.length) {
                resolve(this.purchaseDocumentTemplates)
            } else {
                this.documentTemplateControllerService.getAllDocumentTemplates(
                    this.authContextStorageService.getProjectKey(),
                    true,
                    ['PURCHASE'],
                ).subscribe((data: ListResponseDocumentTemplate) => {
                    this.purchaseDocumentTemplates = data.items

                    resolve(data.items)
                })
            }
        })
    }

    /**
     * Returns promise with loaded subcontract templates. Templates are loaded only once
     * @returns {Promise}
     */
    getSubcontractParamTemplates(): Promise<Array<ContractParamTemplate>> {
        return new Promise(resolve => {
            if (this.subcontractParamTemplates?.length) {
                resolve(this.subcontractParamTemplates)
            } else {
                this.paramTemplateControllerService.getAllParamTemplates(
                    this.authContextStorageService.getProjectKey(),
                    true,
                    true
                ).subscribe((data: ListResponseContractParamTemplate) => {
                    this.subcontractParamTemplates = data.items

                    resolve(data.items)
                })
            }
        })
    }

    getSubcontractDocumentTemplates(): Promise<Array<DocumentTemplate>> {
        return new Promise(resolve => {
            if (this.subcontractDocumentTemplates?.length) {
                resolve(this.subcontractDocumentTemplates)
            } else {
                this.documentTemplateControllerService.getAllDocumentTemplates(
                    this.authContextStorageService.getProjectKey(),
                    true,
                    ['SUBCONTRACT'],
                ).subscribe((data: ListResponseDocumentTemplate) => {
                    this.subcontractDocumentTemplates = data.items

                    resolve(data.items)
                })
            }
        })
    }


    resetLoadedTemplates(): void {
        this.resetLoadedParamTemplates()
        this.resetLoadedDocumentTemplates()
    }

    resetLoadedParamTemplates(): void {
        this.subcontractParamTemplates = []
    }

    resetLoadedDocumentTemplates(): void {
        this.contractDocumentTemplates = []
        this.subcontractDocumentTemplates = []
        this.purchaseDocumentTemplates = []
    }
}
